export default "__VITE_ASSET__CaIjFQDQ__"